import { useCurrentReflection, useCurrentSchoolId } from '@/hooks'
import { reflectionStorage, store, xRbacTokenStorage } from '@/store'
import { Button, Form, InputPassword } from '@seiue/ui'
import { message } from 'antd'
import { RuleObject } from 'antd/es/form'
import { StoreValue } from 'antd/es/form/interface'
import { reflectionApi } from 'packages/sdks-next/growp'
import { EntryComponentsWrapper } from 'packages/theme'
import { validatePassword } from 'packages/utils'
import { useHistory as useOriginHistory } from 'react-router-dom'
import styled from 'styled-components'

/**
 * 账号管理-修改密码
 *
 * @returns React.FC
 */
export const ModifyPassword: React.FC = () => {
  const reflection = useCurrentReflection()

  const schoolId = useCurrentSchoolId()
  const historyOrigin = useOriginHistory()

  const { api: updateReflection } = reflectionApi.useUpdateSelfPassInlogin()

  const [form] = Form.useForm()

  const validateConfirmPassword = (
    rule: RuleObject,
    value: StoreValue,
    callback: (error?: string) => void
  ) => {
    if (!value) {
      callback('请确认密码')
    }
    if (form.getFieldValue('password') !== value) {
      callback('两次输入密码不一致')
    }
    callback()
  }

  const key = 'modifyassword'

  const onSubmit = async () => {
    form.validateFields().then(async (value) => {
      if (reflection?.rid) {
        await updateReflection({
          id: reflection?.rid,
          payload: {
            password: value.password,
            repeatPassword: value.repeatPassword,
          },
        })

        message.loading({ content: '修改成功，3 秒后请重新登录', key })
        setTimeout(() => {
          message.success({ content: '请重新登录', key, duration: 1 })
          store.set(reflectionStorage, undefined)
          store.set(xRbacTokenStorage, undefined)
          historyOrigin.push(`/login/${reflection.schoolId || schoolId}`)
        }, 2000)
      }
    })
  }

  const password = Form.useWatch('password', form)
  const repeatPassword = Form.useWatch('repeatPassword', form)

  return (
    <Wrapper>
      <TitleWrapper>修改密码</TitleWrapper>
      <FormWrapper>
        <EntryComponentsWrapper>
          <Form
            form={form}
            colon={false}
            wrapperCol={{ span: 22 }}
            labelCol={{ span: 2 }}
          >
            <Form.Item
              label="新密码"
              name="password"
              rules={[
                {
                  validator: validatePassword,
                },
              ]}
            >
              <InputPassword
                style={{ width: '484px' }}
                placeholder="包含大小写字母、数字、特殊符号中的任意三种，长度8-128位"
              />
            </Form.Item>
            <Form.Item
              label="确认新密码"
              name="repeatPassword"
              rules={[
                {
                  validator: validateConfirmPassword,
                },
              ]}
            >
              <InputPassword
                style={{ width: '484px' }}
                placeholder="请再次输入新密码"
              />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 2, span: 22 }}>
              <Button
                type="primary"
                onClick={onSubmit}
                disabled={!password || !repeatPassword}
              >
                确认
              </Button>
            </Form.Item>
          </Form>
        </EntryComponentsWrapper>
      </FormWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0px 0px;
  overflow: scroll;
  height: calc(100vh - 110px);
`

const TitleWrapper = styled.div`
  width: 80px;
  height: 28px;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  margin-bottom: 12px;
  color: ${(props) => props.theme.text._1};
`

const FormWrapper = styled.div`
  width: 100%;
`
